import { NuxtClientBase } from './client.base'

export class NuxtClient extends NuxtClientBase {
  /**
   * Метод инициализации дебаг панели
   */
  async initDebugPanel() {
    if (this.gaApp.config.get('isDebugPanelEnabled')) {
      await this.gaApp.services.debugPanel.main.init()
    }
  }

  async init() {
    try {
      this.initAppInterceptors()

      this.gaApp.services.app.bridge.init()

      this.loadRoulettePrizes()

      await this.gaApp.services.app.auth.init()

      this.gaApp.services.cache.main.initCacheStorage()

      // this.initDebugPanel()

      this.initWindowResizeListener()

      this.initCurrentBreakpoint()

      this.detectHoverMedia()
      this.initKeyboardAndPointerListener()

      this.setLocale()

      this.setUserViewGUID()

      this.initAnalytics()

      this.gaApp.router.afterEach(() => {
        if (!this.gaApp.isInit) {
          this.completeAppInit()
        }
      })
    } catch (error) {
      this.onInitError(error, 'INIT-app')
    }
  }
}
